import React from 'react';

function SearchBar({ onSearch, value, placeholder, showMobileSearch, handleMobileSearch, marginTrue, onClick, showBordered, isProductArchived }) {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent form submission (or URL change)
      onSearch(e); // Trigger your search logic here
    }
  };

  return (
    <div
      className={
        (showMobileSearch ? 'title-search-container  search-open ' : `title-search-container  ${marginTrue && 'bom-search-sm'}`) +
        (showBordered && ' search-bordered')
      }
    >
      <input
        onChange={(e) => onSearch(e)}
        name="search"
        type="text"
        value={value}
        onClick={onClick}
        placeholder={placeholder}
        onKeyDown={handleKeyPress}
        disabled={isProductArchived}
      />
      <button aria-label="close" className="btn btn-search-reset" type="button" onClick={() => handleMobileSearch?.(true)}>
        <i className="icon-close" />
      </button>
      <button aria-label="search" className="btn btn-search" type="button" onClick={() => handleMobileSearch?.()}>
        <i className="icon-search" />
      </button>
    </div>
  );
}

export default SearchBar;
